export default "__VITE_ASSET__3hTPiVJD__"